<!--
IMPORTANT:
This file is used only in the vue3 application
Any changes made here should be do in the vue2 file also
Any clarifications contact sai krishna

Vue2File : wwwroot\js\components\rotaionalspecialbanner\RotationalSpecialsContainer\RotationalSpecialsContainer.vue
-->
<template>
  <div>
    <lincoln-new-rotational-banners v-if="isFdDealer && noVehicleAvailable" />
    <primary-rotational-special-banner
      v-if="(loadmobilecompoments || position === '2' || position === '3' || position === '4') && !isFdDealer"
      :designtype="designtype"
    />
  </div>
</template>

<script>
import PrimaryRotationalSpecialBanner from "./RotationalSpecialsContainer.vue";
import LincolnNewRotationalBanners from "../LincolnNewRotationalBanners.vue";

export default {
  props: {
    designtype: {
      type: String,
      default: "",
      required: false,
    },
    loadmobilecompoments: {
      type: String,
      default: "",
      required: true,
    },
    position: {
      type: String,
      default: "",
      required: false,
    },
  },
  components: {
    PrimaryRotationalSpecialBanner,
    LincolnNewRotationalBanners
  },
  data() {
    return {
      isFdDealer: window.isFdDealer,
      noVehicleAvailable:
        window.isFdDealer && !(window.CurrentVehicle && window.CurrentVehicle.length > 4),
    };
  },
  mounted() {
  },
};
</script>
